module.exports = __webpack_public_path__ + "img/stvrt-mapa-centrum_en.9bfd6fd9.jpg";